/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'home': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9 19v-6h6v6h3v-8.09l-6-6-6 6V19h3m3-16.91L21.91 12H20v9h-7v-6h-2v6H4v-9H2.09L12 2.09z"/>'
  }
})
